// extracted by mini-css-extract-plugin
export var desktopTeasers = "TeaserGrid-module--desktopTeasers--7f926";
export var mobileGridTeasers = "TeaserGrid-module--mobileGridTeasers--91221";
export var mobileTeasers = "TeaserGrid-module--mobileTeasers--9d4a6";
export var teaserSlide = "TeaserGrid-module--teaserSlide--30df4";
export var teaserSwiper = "TeaserGrid-module--teaserSwiper--58dab";